import { useState } from "react";
import { Button } from "react-bootstrap";
import WhatsAppChat from "../../components/WhatsAppChat";
import WhatsAppIntroWebsite from "../../components/WhatsAppIntroWebsite";
import WhatsAppIntro from "../../components/WhatsAppIntro";

const WhatsAppScreen = () => {
  const [activeTab, setActiveTab] = useState("chat");

  return (
    <div className="p-3">
      {/* TAB BUTTONS */}
      <div className="mb-3 d-flex gap-3">
        <Button
          variant={activeTab === "chat" ? "primary" : "outline-primary"}
          onClick={() => setActiveTab("chat")}
        >
          Chats
        </Button>

        <Button
          variant={activeTab === "intro" ? "primary" : "outline-primary"}
          onClick={() => setActiveTab("intro")}
        >
          Send Intro Messages
        </Button>
      </div>

      {/* TAB CONTENT */}
      {activeTab === "chat" ? (
        <WhatsAppChat />
      ) : (
        <>
          <WhatsAppIntro />
          <br/>
          <WhatsAppIntroWebsite />
        </>
      )}
    </div>
  );
};

export default WhatsAppScreen;